export default function ImpactSection() {
  const stats = [
    { value: '1M+', label: 'People Reached', sub: 'Through awareness campaigns by 2027', icon: 'ri-user-voice-line' },
    { value: '500', label: 'Patients Supported', sub: 'With medication & therapy', icon: 'ri-heart-pulse-line' },
    { value: '500', label: 'Healthcare Workers', sub: 'Receiving specialized training', icon: 'ri-nurse-line' },
    { value: '10', label: 'Support Groups', sub: 'Established in communities', icon: 'ri-team-line' },
  ];

  return (
    <section className="py-24 bg-[#1A0A1E] relative overflow-hidden">
      {/* Decorative purple glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full bg-[#7B2D8B]/20 blur-3xl pointer-events-none"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-4">
          <span className="text-xs font-semibold uppercase tracking-[4px] text-[#C084FC]">Our Vision for 2027</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-white text-center mb-4">
          Measurable <span className="text-[#C084FC]">Impact</span>
        </h2>
        <p className="text-gray-400 text-center max-w-xl mx-auto mb-16 leading-relaxed">
          By 2027, IKIRU is committed to achieving significant milestones that will profoundly transform epilepsy care and awareness across Nigeria and Africa.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-8 rounded-2xl bg-white/5 border border-purple-500/20">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#7B2D8B]/30 mx-auto mb-4">
                <i className={`${stat.icon} text-[#C084FC] text-xl`}></i>
              </div>
              <div className="text-5xl font-extrabold text-white mb-2">{stat.value}</div>
              <div className="text-[#C084FC] font-semibold text-sm mb-1">{stat.label}</div>
              <div className="text-gray-500 text-xs leading-snug">{stat.sub}</div>
            </div>
          ))}
        </div>

        {/* Purple ribbon divider */}
        <div className="w-24 h-1 rounded-full bg-gradient-to-r from-[#7B2D8B] to-[#C084FC] mx-auto mb-12"></div>

        {/* Testimonial */}
        <div className="max-w-3xl mx-auto text-center">
          <div className="text-5xl text-[#C084FC] font-serif mb-6">&ldquo;</div>
          <blockquote className="text-white text-xl md:text-2xl font-light italic leading-relaxed mb-8">
            Before IKIRU found me, I was hidden away by my family. They thought I was cursed. Today, I run a small business and lead a support group in my community. IKIRU gave me back my life.
          </blockquote>
          <div className="flex items-center justify-center gap-3">
            <div className="w-14 h-14 flex items-center justify-center rounded-full overflow-hidden bg-[#7B2D8B]/30">
              <img
                src="https://readdy.ai/api/search-image?query=portrait%20of%20a%20confident%20young%20African%20woman%20smiling%20warmly%2C%20close-up%20headshot%2C%20natural%20lighting%2C%20simple%20background%2C%20authentic%20and%20genuine%20expression&width=100&height=100&seq=test001&orientation=squarish"
                alt="Amara O."
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="text-left">
              <div className="text-white font-semibold text-sm">Amara O.</div>
              <div className="text-gray-500 text-xs">Epilepsy Survivor & Community Leader, Lagos</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
